var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 70,
    viewBox: "0 0 76 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M70.5682 39.1308C70.5682 50.4351 64.4699 60.373 55.3847 65.7147C55.3847 65.7147 55.3224 65.7768 55.2602 65.7768C54.6379 66.1494 54.0156 66.46 53.3934 66.7705C53.0822 66.9569 52.7711 67.0811 52.4599 67.2053C52.3355 67.2674 52.211 67.3296 52.0866 67.3917H52.0244C51.8999 67.4538 51.7132 67.5159 51.5888 67.578C50.6553 68.0128 49.6597 68.3233 48.6641 68.6339C48.5396 68.696 48.3529 68.7581 48.2285 68.7581C48.1662 68.7581 48.104 68.8202 48.0418 68.8202C47.9796 68.8202 47.9173 68.8202 47.9173 68.8824C47.8551 68.8824 47.7929 68.8824 47.7306 68.9445C46.4239 69.3171 45.0549 69.5656 43.6236 69.7519C42.3168 69.9383 41.0101 70.0004 39.7033 70.0004C37.5875 70.0004 35.534 69.814 33.5427 69.3792C33.4183 69.3792 33.2938 69.3171 33.1694 69.3171C32.7338 69.255 32.2982 69.1308 31.8626 69.0066C31.427 68.8824 30.9914 68.7581 30.5558 68.6339C28.8134 68.0749 27.071 67.3917 25.4531 66.5842C15.4967 61.4289 8.71387 51.0563 8.71387 39.1308C8.71387 22.0501 22.5906 8.26123 39.641 8.26123C56.7537 8.26123 70.5682 22.0501 70.5682 39.1308Z",
    fill: "url(#paint0_linear_10844_805)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9655 25.0929C33.9786 22.6705 32.4229 18.6333 32.9829 14.8445C33.6052 10.5587 36.6544 9.75128 38.2101 10.4345C39.3302 10.9314 40.0147 12.4221 39.3924 13.5401C38.3345 15.5277 34.2897 14.7202 33.4808 11.3041C33.1696 10.0618 33.4808 8.69538 34.2275 7.63948C35.4721 5.96246 37.7745 5.34135 39.828 5.03079C40.3258 5.03079 40.8236 4.96867 41.2592 4.90656C42.3793 4.78234 43.7483 4.596 45.1796 4.40967",
    stroke: "#D8E2EE",
    strokeWidth: 0.625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2914 5.15551L46.3623 6.02508L46.6734 2.73315",
    fill: "#D8E2EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6757 1.11801L59.8045 1.61491L49.7236 7.26708L47.11 3.41615L46.6744 2.73292L44.8076 0L59.0578 0.993789L60.6757 1.11801Z",
    fill: "#EDF2F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6746 1.11788L59.8034 1.61477L47.1089 3.41601L46.6733 2.73278L59.0567 0.993652L60.6746 1.11788Z",
    fill: "#D8E2EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M9.81327 21.0379C10.6304 20.7728 11.0774 19.8968 10.8119 19.0812C10.5463 18.2657 9.66862 17.8194 8.85154 18.0845C8.03445 18.3496 7.58736 19.2256 7.85294 20.0412C8.11852 20.8567 8.99619 21.303 9.81327 21.0379Z",
    fill: "url(#paint1_linear_10844_805)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M13.2098 15.9715C13.7655 15.7912 14.0695 15.1955 13.8889 14.641C13.7083 14.0864 13.1115 13.7829 12.5558 13.9632C12.0002 14.1434 11.6962 14.7391 11.8768 15.2937C12.0574 15.8483 12.6542 16.1517 13.2098 15.9715Z",
    fill: "url(#paint2_linear_10844_805)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M25.9926 8.6776C26.9567 7.79824 27.024 6.30531 26.143 5.34304C25.262 4.38078 23.7663 4.31357 22.8022 5.19293C21.8382 6.07229 21.7708 7.56523 22.6518 8.52749C23.5328 9.48976 25.0286 9.55696 25.9926 8.6776Z",
    fill: "#00D27B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5788 20.7875C74.9847 20.4173 75.013 19.7887 74.6421 19.3835C74.2712 18.9783 73.6414 18.95 73.2355 19.3203C72.8295 19.6906 72.8012 20.3192 73.1721 20.7243C73.5431 21.1295 74.1729 21.1578 74.5788 20.7875Z",
    fill: "#EDF2F8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9761 51.7385V68.8193C48.8516 68.8814 48.7272 68.8814 48.6027 68.9435C47.1715 69.3162 45.678 69.6267 44.1846 69.8131V51.7385H48.9761Z",
    fill: "#4988FD"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9761 51.7385V68.8193C48.8516 68.8814 48.7272 68.8814 48.6027 68.9435C47.1715 69.3162 45.678 69.6267 44.1846 69.8131V51.7385H48.9761Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3934 51.7385V66.8317C53.0822 67.018 52.7711 67.1423 52.46 67.2665C52.3355 67.3286 52.211 67.3907 52.0866 67.4528H52.0244C51.8999 67.5149 51.7132 67.577 51.5888 67.6391C50.6554 68.0739 49.6597 68.3845 48.6641 68.695V51.7385H53.3934Z",
    fill: "#2767F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3934 51.7385V66.8317C53.0822 67.018 52.7711 67.1423 52.46 67.2665C52.3355 67.3286 52.211 67.3907 52.0866 67.4528H52.0244C51.8999 67.5149 51.7132 67.577 51.5888 67.6391C50.6554 68.0739 49.6597 68.3845 48.6641 68.695V51.7385H53.3934Z",
    fill: "#EDF2F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.3934 58.2603V65.7758C53.1445 65.9 52.8955 66.0242 52.6466 66.1485C52.5222 66.2106 52.3977 66.2727 52.2733 66.3348H52.211C52.0866 66.3969 51.8999 66.459 51.7754 66.5211C50.842 66.9559 49.8464 67.2665 48.8507 67.577C48.7885 67.577 48.7263 67.6391 48.6641 67.6391V66.0242C48.7263 65.8379 48.7885 65.6516 48.8507 65.4652C49.7842 63.0429 50.9665 61.1174 52.3355 59.5025C52.6466 59.0677 53.02 58.6329 53.3934 58.2603Z",
    fill: "#344050"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M53.3943 51.7385H44.1846V57.0801H53.3943V51.7385Z",
    fill: "#1C4F93"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9336 32.8568V51.9872H57.9989V52.0493H28.0674V17.7015H56.5054C56.8788 17.6394 57.2522 17.6394 57.6878 17.6394C58.1856 17.6394 58.6212 17.6394 59.119 17.7015C59.7413 17.7636 60.3013 17.8257 60.8614 17.95C63.7861 18.5711 66.3997 20.0618 68.4532 22.0493C71.2534 24.8444 72.9336 28.6953 72.9336 32.8568Z",
    fill: "url(#paint3_linear_10844_805)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8605 18.0117V32.2353C60.8605 32.7322 60.4872 33.1049 59.9894 33.1049C59.4915 33.1049 59.1182 32.7322 59.1182 32.2353V17.7012C59.6782 17.7633 60.3005 17.8875 60.8605 18.0117Z",
    fill: "url(#paint4_linear_10844_805)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3009 37.3289C62.1912 37.3289 63.7235 35.7994 63.7235 33.9127C63.7235 32.026 62.1912 30.4966 60.3009 30.4966C58.4107 30.4966 56.8784 32.026 56.8784 33.9127C56.8784 35.7994 58.4107 37.3289 60.3009 37.3289Z",
    fill: "#2A7BE4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8614 36.8943C62.8204 36.8943 64.4084 35.3648 64.4084 33.4782C64.4084 31.5915 62.8204 30.062 60.8614 30.062C58.9025 30.062 57.3145 31.5915 57.3145 33.4782C57.3145 35.3648 58.9025 36.8943 60.8614 36.8943Z",
    fill: "#D5DAE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.048 36.8943C62.9382 36.8943 64.4705 35.3648 64.4705 33.4782C64.4705 31.5915 62.9382 30.062 61.048 30.062C59.1578 30.062 57.6255 31.5915 57.6255 33.4782C57.6255 35.3648 59.1578 36.8943 61.048 36.8943Z",
    fill: "#EAEEF9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.048 34.7825C61.7697 34.7825 62.3548 34.1985 62.3548 33.4782C62.3548 32.7578 61.7697 32.1738 61.048 32.1738C60.3263 32.1738 59.7412 32.7578 59.7412 33.4782C59.7412 34.1985 60.3263 34.7825 61.048 34.7825Z",
    fill: "#D5DAE8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9398 31.3658V52.049H12.4482V31.3658C12.4482 24.844 17.0531 19.3782 23.1514 18.0117C24.1471 17.7633 25.1427 17.7012 26.2006 17.7012H29.312C36.157 17.7012 41.8197 22.6701 42.8776 29.254C42.8776 29.8751 42.9398 30.6204 42.9398 31.3658Z",
    fill: "url(#paint5_linear_10844_805)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0436 16.894V33.3537C62.0436 33.8506 61.6703 34.2232 61.1725 34.2232C60.6746 34.2232 60.3013 33.8506 60.3013 33.3537V16.894H62.0436Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0854 43.2923C38.0854 44.5967 37.0275 45.6526 35.7207 45.6526C11.3275 45.6526 12.8832 45.7768 12.0742 45.2799C11.3897 44.8451 10.9541 44.0998 10.9541 43.2923C12.3853 27.0811 12.1364 27.2675 13.1321 26.3358C14.0655 25.5283 12.7587 25.7768 37.0275 25.7768C37.7742 25.7768 38.4588 26.1494 38.8943 26.6463C39.7033 27.7022 39.5166 27.3296 38.0854 43.2923Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1438 27.0189C26.8227 37.4537 27.1338 37.64 25.3292 37.64C23.4002 37.64 23.5868 37.3916 12.6348 27.0189C13.5682 25.2797 13.0081 25.7766 37.0903 25.7766C37.9614 25.7766 38.7704 26.2735 39.1438 27.0189Z",
    fill: "#EAEEF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46063 30.4348H1.37103C0.997662 30.4348 0.686523 30.1243 0.686523 29.7516C0.686523 29.3789 0.997662 29.0684 1.37103 29.0684H9.46063C9.834 29.0684 10.1451 29.3789 10.1451 29.7516C10.1451 30.1243 9.834 30.4348 9.46063 30.4348Z",
    fill: "url(#paint6_linear_10844_805)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08742 34.2864H4.42034C4.04698 34.2864 3.73584 33.9758 3.73584 33.6032C3.73584 33.2305 4.04698 32.9199 4.42034 32.9199H9.08742C9.46079 32.9199 9.77193 33.2305 9.77193 33.6032C9.77193 33.9758 9.46079 34.2864 9.08742 34.2864Z",
    fill: "url(#paint7_linear_10844_805)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65158 37.9509H6.03802C5.66465 37.9509 5.35352 37.6404 5.35352 37.2677C5.35352 36.895 5.66465 36.5845 6.03802 36.5845H8.71381C9.08718 36.5845 9.39832 36.895 9.39832 37.2677C9.39832 37.6404 9.08718 37.9509 8.65158 37.9509Z",
    fill: "url(#paint8_linear_10844_805)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5385 37.7642H31.7382C31.5515 37.7642 31.4271 37.8884 31.4271 38.0747L31.3648 38.4474L31.2404 39.4412L31.1782 40.1244L31.0537 40.8698C31.0537 40.9319 31.0537 40.994 31.0537 41.0561C31.1159 41.1803 31.2404 41.3045 31.3648 41.3045H34.1651C34.3518 41.3045 34.4762 41.1803 34.4762 40.994L34.8496 38.1989C34.9118 37.9505 34.7874 37.7642 34.5385 37.7642ZM33.854 40.3107C33.854 40.3729 33.7917 40.4971 33.6673 40.4971H32.2983H32.1116C31.9871 40.4971 31.9249 40.3729 31.9249 40.3107L31.9871 39.8138L32.0494 39.1306L32.1116 38.8201C32.1116 38.7579 32.1738 38.6337 32.2983 38.6337H33.854C33.9784 38.6337 34.0406 38.7579 34.0406 38.8201L33.854 40.3107Z",
    fill: "url(#paint9_linear_10844_805)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2983 38.5719C32.1739 38.5719 32.1116 38.634 32.1116 38.7582L32.0494 39.0687C31.7383 39.2551 31.4893 39.3793 31.2404 39.4414C31.0538 39.5035 30.8671 39.5035 30.6804 39.5035C30.1203 39.5035 29.6847 39.3172 29.3114 39.1309C28.7513 38.8824 28.6269 38.8824 28.4402 39.0687C28.2535 39.2551 28.0046 39.2551 27.8179 39.1309C27.6312 38.9445 27.6312 38.6961 27.7557 38.5097C28.378 37.7644 29.1247 38.075 29.6847 38.3234C30.2448 38.5719 30.6804 38.8203 31.3649 38.4476C31.4271 38.3855 31.5516 38.3855 31.6138 38.3234C31.8005 38.1992 32.1116 38.2613 32.2361 38.4476C32.2983 38.4476 32.2983 38.5097 32.2983 38.5719Z",
    fill: "url(#paint10_linear_10844_805)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2984 40.435L32.2361 40.4971C31.8005 40.8077 31.4272 40.9319 31.116 40.994C30.9916 40.994 30.8671 40.994 30.8049 40.994C30.2448 40.994 29.8093 40.8077 29.4359 40.6213C28.8758 40.3729 28.7514 40.3729 28.5647 40.5592C28.378 40.7456 28.1291 40.7456 27.9424 40.6213C27.7557 40.435 27.7557 40.1866 27.8802 40.0002C28.5025 39.2549 29.2492 39.5654 29.747 39.8139C30.1826 40.0002 30.6182 40.1866 31.116 40.0623C31.3027 40.0002 31.4272 39.9381 31.6761 39.8139C31.7383 39.7518 31.8628 39.7518 31.9872 39.7518L31.925 40.2487C31.925 40.3729 31.9872 40.435 32.1117 40.435H32.2984Z",
    fill: "url(#paint11_linear_10844_805)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M42.9396 34.2233L42.7529 29.1922C41.695 22.6705 36.0323 17.6394 29.1872 17.6394H26.0758C25.018 17.6394 24.0223 17.7636 23.0267 17.95L22.6533 18.2605L30.3696 49.9375L42.8773 50.6208V34.2233H42.9396Z",
    fill: "url(#paint12_linear_10844_805)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4446 16.3349C70.6935 16.5212 70.5691 16.956 70.1957 16.956H62.1061H60.2393V10.1858H70.1957C70.5068 10.1858 70.6935 10.5585 70.4446 10.8069L67.831 12.9808C67.4577 13.2914 67.4577 13.8504 67.831 14.1609L70.4446 16.3349Z",
    fill: "url(#paint13_linear_10844_805)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7836 63.7268C34.9124 65.0312 33.8545 67.143 33.2322 68.9442C33.17 69.0684 33.1078 69.2548 33.1078 69.379C32.6722 69.3169 32.2366 69.1926 31.801 69.0684C31.4276 68.1989 31.1787 67.2672 31.1787 67.2672C31.4276 66.9566 31.6143 66.7082 31.8632 66.4597C33.0455 64.969 34.2901 63.9753 35.7836 63.7268Z",
    fill: "#B6C2D2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4802 69.4409C33.3557 69.4409 33.2313 69.3788 33.1068 69.3788C32.6712 69.3167 32.2356 69.1924 31.8 69.0682C31.4889 69.0061 31.24 68.8819 30.9288 68.8198C30.8044 68.7577 30.6799 68.7577 30.5555 68.6956C30.431 68.6334 30.3065 68.6334 30.1199 68.5713C28.5019 68.0744 26.9463 67.3912 25.4528 66.6459C23.8971 64.0372 23.0259 60.8074 21.5324 56.3974C21.5324 56.3353 21.5324 56.3353 21.4702 56.2732C21.4702 56.2732 21.5947 56.2732 21.9058 56.3974C22.0925 56.5216 22.4036 56.6459 22.777 56.8943C23.5237 57.3912 24.7061 58.2608 26.4484 59.6893C28.6264 61.4906 30.4932 64.1614 31.8 66.3974C32.3601 67.3912 32.8579 68.2608 33.2313 68.944C33.3557 69.0682 33.4179 69.2546 33.4802 69.4409Z",
    fill: "#EDF2F8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9288 68.7575C30.8044 68.6954 30.6799 68.6954 30.5555 68.6333C30.431 68.5712 30.3065 68.5712 30.1199 68.5091C27.2574 62.7327 24.0216 59.0681 22.0925 56.9563C21.9058 56.7078 21.7191 56.5215 21.5324 56.3352C21.5324 56.273 21.5324 56.273 21.4702 56.2109C21.4702 56.2109 21.5947 56.2109 21.9058 56.3352C22.0925 56.4594 22.4036 56.5836 22.777 56.8321C24.7683 59.0681 28.0664 62.8569 30.9288 68.7575Z",
    fill: "#D8E2EE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.975 68.8196C49.0373 68.8196 49.0373 68.8196 49.0995 68.8196C49.0373 68.8196 48.9128 68.8818 48.8506 68.8818C48.8506 68.8196 48.9128 68.8196 48.975 68.8196Z",
    fill: "#D5DAE8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1616 68.758C49.2238 68.758 49.2238 68.758 49.286 68.6958C49.2238 68.6958 49.0993 68.758 49.0371 68.758C49.0993 68.758 49.0993 68.758 49.1616 68.758Z",
    fill: "#D5DAE8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0524 55.155C60.0524 55.155 59.9901 55.2793 59.8657 55.5277C59.119 56.8942 56.5676 61.6147 55.3853 65.6519C55.3853 65.6519 55.3231 65.714 55.2608 65.714C54.6386 66.0867 54.0163 66.3973 53.394 66.7078C53.0829 66.8942 52.7717 67.0184 52.4606 67.1426C52.3361 67.2047 52.2117 67.2668 52.0872 67.3289H52.025C51.9005 67.3911 51.7139 67.4532 51.5894 67.5153C50.656 67.9501 49.6603 68.2606 48.6647 68.5712C48.5402 68.6333 48.3536 68.6954 48.2291 68.6954C48.1669 68.6954 48.1046 68.7575 48.0424 68.7575C47.9802 68.7575 47.918 68.7575 47.918 68.8196C48.1669 68.0122 48.4158 67.2047 48.7269 66.5215C49.6603 64.0991 50.8427 62.1737 52.2117 60.5588C52.6473 60.0619 53.0829 59.565 53.5185 59.1302C55.3231 57.3289 57.2521 56.1488 59.0567 55.5277C59.3056 55.4035 59.679 55.2793 60.0524 55.155Z",
    fill: "#EDF2F8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0518 55.155C60.0518 55.155 59.9896 55.2793 59.8652 55.5277C57.5005 57.5774 55.3225 60.8072 53.3935 64.9687C53.0823 65.714 52.7712 66.3973 52.4601 67.2047C52.3356 67.2668 52.2111 67.3289 52.0867 67.3911H52.0245C51.9 67.4532 51.7133 67.5153 51.5889 67.5774C51.6511 67.4532 51.7133 67.3911 51.7133 67.3911C52.2734 66.0246 52.8334 64.7202 53.3935 63.5401C55.0736 60.124 56.9404 57.3911 58.9317 55.5277C59.3051 55.4035 59.6785 55.2793 60.0518 55.155Z",
    fill: "#D8E2EE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51.464 68.8818C51.3395 69.1924 51.2773 69.503 51.1528 69.8135",
    stroke: "white",
    strokeWidth: 0.625,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10844_805",
    x1: 74.3135,
    y1: 97.0005,
    x2: 25.1263,
    y2: -3.40781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10844_805",
    x1: 14.2501,
    y1: 17.4554,
    x2: 9.64279,
    y2: 21.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10844_805",
    x1: 16.2269,
    y1: 13.5354,
    x2: 13.0939,
    y2: 16.5138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10844_805",
    x1: 127.347,
    y1: 29.4657,
    x2: 54.0345,
    y2: 75.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10844_805",
    x1: 59.9846,
    y1: 30.9691,
    x2: 59.9846,
    y2: 22.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7BE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A7BE4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10844_805",
    x1: 14.9176,
    y1: 46.2437,
    x2: 40.4969,
    y2: 23.5363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1970E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4695FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10844_805",
    x1: -1.08487,
    y1: 29.7479,
    x2: 10.1767,
    y2: 29.7479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC97A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10844_805",
    x1: 2.60541,
    y1: 33.5994,
    x2: 9.79208,
    y2: 33.5994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC97A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10844_805",
    x1: 4.59601,
    y1: 37.264,
    x2: 9.41182,
    y2: 37.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC97A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10844_805",
    x1: 30.3399,
    y1: 39.5248,
    x2: 34.8782,
    y2: 39.5248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC97A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10844_805",
    x1: 26.802,
    y1: 38.769,
    x2: 40.3135,
    y2: 38.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC97A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#E63756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10844_805",
    x1: 26.9498,
    y1: 40.2595,
    x2: 38.813,
    y2: 39.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC97A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63756"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10844_805",
    x1: 42.1682,
    y1: 33.7913,
    x2: 29.2893,
    y2: 34.3914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C1E82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001DB5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10844_805",
    x1: 72.3135,
    y1: 13.5525,
    x2: 59.8135,
    y2: 13.5525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC97A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.8b4e16362921069be592d199c25189f3.svg";
export { ForwardRef as ReactComponent };